import axios from "axios";
import { config } from "../../config";

import { PackageItineraryRequest, PackageItineraryResponse } from "redmond";
import { packageItinerariesApiPrefix } from "../paths";

export const fetchPackages = async (
  req: PackageItineraryRequest
): Promise<PackageItineraryResponse> => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.put(`${packageItinerariesApiPrefix}`, req, {
        baseURL: config.baseURL,
      });
      resolve(res.data);
    } catch (e) {
      reject(e);
    }
  });
};
